// The idea here is identical to the load function
// for the callrail script in slopejet.js. See the comment there.
let script
export function load() {
  // Guard against accidental server use.
  if(typeof window === "undefined" || typeof document === "undefined")
    return;

  /* eslint-disable no-undef */
  if (script) {
    document.body.removeChild(script)
  }

  window.versaTag = {}
  versaTag.id = "5480"
  versaTag.sync = 0
  versaTag.dispType = "js"
  versaTag.ptcl = "HTTPS"
  versaTag.bsUrl = "bs.serving-sys.com/BurstingPipe"
  //VersaTag activity parameters include all conversion parameters including custom parameters and Predefined parameters. Syntax: "ParamName1":"ParamValue1", "ParamName2":"ParamValue2". ParamValue can be empty.
  versaTag.activityParams = {
    //Predefined parameters:
    "Session": ""
    //Custom parameters:
  }
  //Static retargeting tags parameters. Syntax: "TagID1":"ParamValue1", "TagID2":"ParamValue2". ParamValue can be empty.
  versaTag.retargetParams = {}
  //Dynamic retargeting tags parameters. Syntax: "TagID1":"ParamValue1", "TagID2":"ParamValue2". ParamValue can be empty.
  versaTag.dynamicRetargetParams = {}
  // Third party tags conditional parameters and mapping rule parameters. Syntax: "CondParam1":"ParamValue1", "CondParam2":"ParamValue2". ParamValue can be empty.
  versaTag.conditionalParams = {}

  script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://secure-ds.serving-sys.com/SemiCachedScripts/ebOneTag.js'
  document.body.appendChild(script)
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./client/utility/versa.js